import { useState, useEffect, useCallback, useMemo } from 'react';
import { destinationAPI } from '../services/api';

export const useDestinations = (initialParams = {}) => {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [params, setParams] = useState(initialParams);

    const paramsKey = useMemo(() => JSON.stringify(params), [params]);

    const fetchDestinations = useCallback(async () => {
        try {
            setLoading(true);
            const response = await destinationAPI.getAllDestinations(params);
            setDestinations(response.data);
            setError(null);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch destinations');
            console.error('Error fetching destinations:', err);
        } finally {
            setLoading(false);
        }
    }, [params]);

    useEffect(() => {
        fetchDestinations();
    }, [fetchDestinations, paramsKey]);

    return { destinations, loading, error, setParams, refetch: fetchDestinations };
};

export const useDestination = (id) => {
    const [destination, setDestination] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchDestination = useCallback(async () => {
        try {
            setLoading(true);
            const response = await destinationAPI.getDestinationById(id);
            setDestination(response.data);
            setError(null);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch destination');
            console.error('Error fetching destination:', err);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        if (id) {
            fetchDestination();
        }
    }, [id, fetchDestination]);

    return { destination, loading, error, refetch: fetchDestination };
};
